"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var style_1 = require("../../../style");
var SvgIcPremiumCircular = function () { return (react_1.default.createElement(style_1.SvgIcon, { height: '1em', viewBox: '0 0 24 24', width: '1em' },
    react_1.default.createElement("g", { fill: 'none', fillRule: 'evenodd' },
        react_1.default.createElement("circle", { cx: 12, cy: 12, fill: '#d1994c', r: 10 }),
        react_1.default.createElement("g", { fill: '#fff' },
            react_1.default.createElement("path", { d: 'M14.31 9.424l.047.218-2.104 6.787h-.506L9.643 9.642l.047-.218L11.795 7h.41zM12 7.539l-1.814 2.09L12 15.479l1.814-5.85z', fillRule: 'nonzero' }),
            react_1.default.createElement("path", { d: 'M9.49 7.51L7.103 9.838 12 16.52l4.896-6.683-2.385-2.326zM9.38 7h5.238c.07 0 .136.027.185.075l2.62 2.553a.25.25 0 0 1 .027.33l-5.238 7.15a.266.266 0 0 1-.426 0l-5.238-7.15a.25.25 0 0 1 .028-.33l2.619-2.553A.265.265 0 0 1 9.38 7z', fillRule: 'nonzero' }),
            react_1.default.createElement("path", { d: 'M7.596 9.357h8.808l.492.48-.08.11H7.184l-.08-.11z' }))))); };
exports.default = SvgIcPremiumCircular;
